import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import MapfreLogo from "src/assets/icons/mapfre_logo.png";
import { CheckoutError } from "src/types/error";

const ApiErrorPage: React.FC<{
  errorMessage: CheckoutError;
  showError?: boolean;
}> = ({ errorMessage, showError = true }) => {
  useEffect(() => {
    Sentry.captureMessage("ApiError", {
      level: "error",
      extra: {
        statusCode: errorMessage?.statusCode,
        cause: errorMessage?.cause,
        requestId: errorMessage?.requestId,
      },
    });
  }, [errorMessage]);

  return (
    <main className="flex h-screen w-full overflow-hidden">
      {/* Left column: message */}
      <section className="flex w-full shrink-0 flex-col items-center justify-between py-10">
        <div />
        <div className="flex flex-col items-center px-6 text-center">
          <h1 className="text-primary-1 mb-6 text-6xl font-bold">Oops!</h1>
          <h2 className="text-xl font-semibold">
            Hmmm, não encontramos seu pedido.
          </h2>
          <p className="mt-2 text-gray-600">
            Parece que esse pedido já foi pago, expirou ou não existe.
          </p>

          {showError && errorMessage?.requestId && (
            <div className="mt-6 space-y-1 text-center">
              <p className="text-3xl font-bold">{errorMessage.statusCode}</p>
              <p className="text-sm text-gray-500">
                ID: {errorMessage.requestId}
              </p>
            </div>
          )}
        </div>
        <footer>
          <img src={MapfreLogo} alt="Mapfre" />
        </footer>
      </section>
    </main>
  );
};

export default ApiErrorPage;
